import {action, makeObservable, observable} from 'mobx';
import {getDname} from '../../_shared/GWTBridge/invoke/genPage';

class CompanyStore {
    @observable
    currentCompany = null;

    constructor() {
        makeObservable(this);
        this.setCompany(getDname());
    }

    @action
    setCompany(companyName: string) {
        if (companyName !== this.currentCompany) {
            this.currentCompany = companyName;

            const myEvent = new CustomEvent('companyChange', {
                detail: {companyName}
            });

            window.dispatchEvent(myEvent);
        }
    }
}

export const companyStore = new CompanyStore();
